import { v4 } from 'uuid';

const initialState = {
  group: null,
  updating: false,
};

const update = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_AUTHORIZATION_GROUP':
      return {
        ...state,
        group: action.group || { uuid: v4(), groupId: '', permissions: [] },
      };

    case 'CANCEL_UPDATE_AUTHORIZATION_GROUP':
      return initialState;

    case 'UPDATE_SET_AUTHORIZATION_GROUP_ID':
      return {
        ...state,
        group: { ...state.group, groupId: action.groupId },
      };

    case 'UPDATE_SET_AUTHORIZATION_GROUP_PERMISSIONS':
      return {
        ...state,
        group: { ...state.group, permissions: action.permissions },
      };

    case 'UPDATE_AUTHORIZATION_GROUP_REQUEST':
      return {
        ...state,
        updating: true,
      };

    case 'UPDATE_AUTHORIZATION_GROUP_SUCCESS':
      return initialState;

    case 'UPDATE_AUTHORIZATION_GROUP_FAILURE':
      return {
        ...state,
        updating: false,
      };

    default:
      return state;
  }
};

export default update;

export const getGroup = (state) => state.group;

export const isUpdating = (state) => state.updating;
